import { render, staticRenderFns } from "./RecentlyViewed.vue?vue&type=template&id=4fac8226"
import script from "./RecentlyViewed.vue?vue&type=script&lang=js"
export * from "./RecentlyViewed.vue?vue&type=script&lang=js"
import style0 from "./RecentlyViewed.vue?vue&type=style&index=0&id=4fac8226&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports